import { Component, OnInit, Input } from '@angular/core';
import { CaseService } from '../../../../shared/services/case.service';
import { UntypedFormBuilder } from '@angular/forms';
import { ConveyancingSaleEstateAgentDetailsComponent } from '../../estate-agent-details/conveyancing-sale-estate-agent-details/conveyancing-sale-estate-agent-details.component';
import { ComparerService } from 'src/app/shared/utility/comparer';
import { AuditService } from '../../../../shared/services/audit.service';
import { faHistory, faPlus } from '@fortawesome/pro-light-svg-icons';
import { AuditFormComponent } from 'src/app/case/audit-form/audit-form.component';
import { AddAllowanceComponent } from '../../allowance/add-allowance/add-allowance.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-conveyancing-sale-property-details',
  templateUrl: './conveyancing-sale-property-details.component.html',
  styleUrls: ['./conveyancing-sale-property-details.component.scss']
})
export class ConveyancingSalePropertyDetailsComponent implements OnInit {

  @Input() caseId: number;

  dataLoaded: boolean = false;
  viewInit = false;
  faHistory = faHistory;
  faPlus = faPlus;
  chattels = [1, 2, 3];

  propertyDetails = this.fb.group({
    id: [],
    caseId: [],
    saleAddressSameAsCorrespondenceAddress : [],
    saleAddressLine1 : [],
    saleAddressLine2 : [],
    saleAddressLine3 : [],
    saleAddressLine4 : [],
    saleAddressLine5 : [],
    salePostcode : [],
    propertyIsUnregistered : [],
    titleNumber : [],
    clientFullNameMatchTitleDeeds : [],
    clientFullNameMatchTitleDeedsReason : [],
    statementOfTruthRegardingNameDiscrepencyRequired : [],
    propertyType : [],
    landlordName : [],
    landlordAddressLine1 : [],
    landlordAddressLine2 : [],
    landlordAddressLine3 : [],
    landlordAddressLine4 : [],
    landlordAddressLine5 : [],
    landlordPostcode : [],
    managementCompanyName : [],
    managementCompanyAddressLine1 : [],
    managementCompanyAddressLine2 : [],
    managementCompanyAddressLine3 : [],
    managementCompanyAddressLine4 : [],
    managementCompanyAddressLine5 : [],
    managementCompanyPostcode : [],
    solarPanelsPresent : [],
    solarPanelsOwnedOutright  : [],
    solarPanelsCompany  : [],
    solarPanelsOwnerAddressLine1 : [],
    solarPanelsOwnerAddressLine2 : [],
    solarPanelsOwnerAddressLine3 : [],
    solarPanelsOwnerAddressLine4 : [],
    solarPanelsOwnerAddressLine5 : [],
    solarPanelsOwnerPostcode : [],
    hasSepticTank : [],
    redeemMortgage : [],
    lenderName : [],
    lenderAddressLine1 : [],
    lenderAddressLine2 : [],
    lenderAddressLine3 : [],
    lenderAddressLine4 : [],
    lenderAddressLine5 : [],
    lenderPostcode : [],
    propertySoleNameTransferIntoJointNames : [],
    propertySoleNameTransferIntoJointNamesReason : [],
    propertyJointNameTransferIntoSoleName : [],
    propertyJointNameTransferIntoSoleNameReason : [],
    removalOfRestriction : [],
    removalOfRestrictionReason : [],
    agreedSalePrice : [],
    buyerSolicitorName : [],
    buyerSolicitorEmailAddress : [],
    buyerSolicitorContactNumber : [],
    buyer1Name : [],
    buyer2Name : [],
    buyerSolicitorReference : [],
    buyerSolicitorAddressLine1 : [],
    buyerSolicitorAddressLine2 : [],
    buyerSolicitorAddressLine3 : [],
    buyerSolicitorAddressLine4 : [],
    buyerSolicitorAddressLine5 : [],
    buyerSolicitorPostcode : [],
    hasSecondLender : [],
    lender2Name : [],
    lender2AddressLine1 : [],
    lender2AddressLine2 : [],
    lender2AddressLine3 : [],
    lender2AddressLine4 : [],
    lender2AddressLine5 : [],
    lender2Postcode : [],
    hasThirdLender : [],
    lender3Name : [],
    lender3AddressLine1 : [],
    lender3AddressLine2 : [],
    lender3AddressLine3 : [],
    lender3AddressLine4 : [],
    lender3AddressLine5 : [],
    lender3Postcode : [],
    redemptionAmount: [],
    redemptionAmount2: [],
    redemptionAmount3: [],
    currentMortgageAccountNumber: [],
    titleGuaranteeType: [null],
    chattels: [],
    adlRedeemMortgageLender1: [],
    lender1SortCode: [],
    lender1AccountNumber: [],
    adlRedeemMortgageLender2: [],
    lender2SortCode: [],
    lender2AccountNumber: [],
    adlRedeemMortgageLender3: [],
    lender3SortCode: [],
    lender3AccountNumber: []
  }, { });

  initialDetails = this.fb.group({
    id: [],
    caseId: [],
    saleAddressSameAsCorrespondenceAddress : [],
    saleAddressLine1 : [],
    saleAddressLine2 : [],
    saleAddressLine3 : [],
    saleAddressLine4 : [],
    saleAddressLine5 : [],
    salePostcode : [],
    propertyIsUnregistered : [],
    titleNumber : [],
    clientFullNameMatchTitleDeeds : [],
    clientFullNameMatchTitleDeedsReason : [],
    statementOfTruthRegardingNameDiscrepencyRequired : [],
    propertyType : [],
    landlordName : [],
    landlordAddressLine1 : [],
    landlordAddressLine2 : [],
    landlordAddressLine3 : [],
    landlordAddressLine4 : [],
    landlordAddressLine5 : [],
    landlordPostcode : [],
    managementCompanyName : [],
    managementCompanyAddressLine1 : [],
    managementCompanyAddressLine2 : [],
    managementCompanyAddressLine3 : [],
    managementCompanyAddressLine4 : [],
    managementCompanyAddressLine5 : [],
    managementCompanyPostcode : [],
    solarPanelsPresent : [],
    solarPanelsOwnedOutright  : [],
    solarPanelsCompany  : [],
    solarPanelsOwnerAddressLine1 : [],
    solarPanelsOwnerAddressLine2 : [],
    solarPanelsOwnerAddressLine3 : [],
    solarPanelsOwnerAddressLine4 : [],
    solarPanelsOwnerAddressLine5 : [],
    solarPanelsOwnerPostcode : [],
    hasSepticTank : [],
    redeemMortgage : [],
    lenderName : [],
    lenderAddressLine1 : [],
    lenderAddressLine2 : [],
    lenderAddressLine3 : [],
    lenderAddressLine4 : [],
    lenderAddressLine5 : [],
    lenderPostcode : [],
    propertySoleNameTransferIntoJointNames : [],
    propertySoleNameTransferIntoJointNamesReason : [],
    propertyJointNameTransferIntoSoleName : [],
    propertyJointNameTransferIntoSoleNameReason : [],
    removalOfRestriction : [],
    removalOfRestrictionReason : [],
    agreedSalePrice : [],
    buyerSolicitorName : [],
    buyerSolicitorEmailAddress : [],
    buyerSolicitorContactNumber : [],
    buyer1Name : [],
    buyer2Name : [],
    buyerSolicitorReference : [],
    buyerSolicitorAddressLine1 : [],
    buyerSolicitorAddressLine2 : [],
    buyerSolicitorAddressLine3 : [],
    buyerSolicitorAddressLine4 : [],
    buyerSolicitorAddressLine5 : [],
    buyerSolicitorPostcode : [],
    hasSecondLender : [],
    lender2Name : [],
    lender2AddressLine1 : [],
    lender2AddressLine2 : [],
    lender2AddressLine3 : [],
    lender2AddressLine4 : [],
    lender2AddressLine5 : [],
    lender2Postcode : [],
    hasThirdLender : [],
    lender3Name : [],
    lender3AddressLine1 : [],
    lender3AddressLine2 : [],
    lender3AddressLine3 : [],
    lender3AddressLine4 : [],
    lender3AddressLine5 : [],
    lender3Postcode : [],
    redemptionAmount: [],
    redemptionAmount2: [],
    redemptionAmount3: [],
    currentMortgageAccountNumber: [],
    titleGuaranteeType: [null],
    chattels: [],
    adlRedeemMortgageLender1: [],
    lender1SortCode: [],
    lender1AccountNumber: [],
    adlRedeemMortgageLender2: [],
    lender2SortCode: [],
    lender2AccountNumber: [],
    adlRedeemMortgageLender3: [],
    lender3SortCode: [],
    lender3AccountNumber: []
  }, { });

  constructor(
              public activeModal: NgbActiveModal,
              private caseService: CaseService,
              private fb: UntypedFormBuilder,
              private comp: ComparerService,
              private auditService: AuditService,
              private modalService: ModalService) {
  }

  ngOnInit(): void {
    this.caseService.getConveyancingSalePropertyDetails(this.caseId).subscribe((response : any) => {

      this.propertyDetails.patchValue(response.propertyDetails);
      this.initialDetails.patchValue(response.propertyDetails);
      this.dataLoaded = true;
    });
  }

  ngAfterContentInit() : void {
    this.viewInit = true;
    //this.loadData();
  }

  loadData(){
    this.caseService.getConveyancingSalePropertyDetails(this.caseId).subscribe((response : any) => {

      console.log(response.propertyDetails);
      this.propertyDetails.patchValue(response.propertyDetails);
      this.dataLoaded = true;
    });
  }

  updateField(){

    this.caseService.updateConveyancingSalePropertyDetails(this.propertyDetails.value).subscribe((response : any) => {

    }, (error : any) => {


    });
  }

  openEstateAgent(){

    this.close();

    const modalRef = this.modalService.openLgModal(ConveyancingSaleEstateAgentDetailsComponent);
    modalRef.componentInstance.caseId = this.caseId;
  }

  close(){

    if(this.comp.objectsDifferent(this.initialDetails.value, this.propertyDetails.value))
    {
      this.auditService.auditForm(this.caseId, 'PropertyDetails', this.initialDetails.value, this.propertyDetails.value).subscribe((response : any) => {
        this.activeModal.close(true);
      });
    }
    else
      this.activeModal.dismiss();
  }

  openAuditForForm(){

    const modalRef = this.modalService.openWithOptions(AuditFormComponent, {size: 'xl'});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.formName = "PropertyDetails";

  }

}
